import { render, staticRenderFns } from "./UFIReportList.vue?vue&type=template&id=4ccb8940&scoped=true"
import script from "./UFIReportList.vue?vue&type=script&lang=js"
export * from "./UFIReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb8940",
  null
  
)

export default component.exports